import { Capacitor } from '@capacitor/core';

export const isCapacitorPlatform = () => {
  return typeof window !== 'undefined' &&
    window !== null &&
    (window as any).Capacitor &&
    (window as any).Capacitor.isNativePlatform();
};

/**
 * True solo su Android nativo. Su Android il premium è concesso da RevenueCat
 * (webhook → profiles.is_premium); il flusso Stripe `check-subscription` non va
 * eseguito, altrimenti azzererebbe l'entitlement (clobbering — issue #1334).
 */
export const isAndroidNative = (): boolean => Capacitor.getPlatform() === 'android';
